module.exports = __webpack_public_path__ + "static/1-902ec3f73a3b2e2f29ae4b5c8211e294.jpg";